<template>
  <div>
    <ButtonBack class="mb_m"/>
    <input-name />
    <input-branch-name />
    <input-account-type />
    <input-account-number />
    <slot></slot>
  </div>
</template>

<script>
import ButtonBack from '@/components/ButtonBack'
import InputName from '@/components/Bank/InputName'
import InputBranchName from '@/components/Bank/InputBranchName'
import InputAccountType from '@/components/Bank/InputAccountType'
import InputAccountNumber from '@/components/Bank/InputAccountNumber'

export default {
  components: {
    ButtonBack,
    InputName,
    InputBranchName,
    InputAccountType,
    InputAccountNumber
  }
}
</script>
